// STRUCTURED LOGGER — leveled, context-aware logging (migration Phase 5 leaf module).
// Replaces silent `catch (e) {}` swallowing on critical paths with logged, contextual errors.
// Levels: error < warn < info < debug. Set Logger.level = 'debug' in the console to see
// everything; default 'warn' keeps output quiet. A ring buffer keeps the last 200 events so the
// debug panel can display them without re-instrumenting anything.
export const Logger = {
    LEVELS: { error: 1, warn: 2, info: 3, debug: 4 },
    level: 'warn',                 // current threshold (name)
    buffer: [],                    // ring buffer of recent events
    MAX: 200,
    _emit(lvl, msg, context) {
        const rank = this.LEVELS[lvl] || 2;
        const entry = { t: Date.now(), level: lvl, msg, context: context || {} };
        this.buffer.push(entry);
        if (this.buffer.length > this.MAX) this.buffer.shift();
        if (rank > (this.LEVELS[this.level] || 2)) return; // below threshold → buffer only
        const tag = `[${lvl.toUpperCase()}]`;
        const fn = lvl === 'error' ? console.error : lvl === 'warn' ? console.warn : console.log;
        if (context && Object.keys(context).length) fn(`${tag} ${msg}`, context);
        else fn(`${tag} ${msg}`);
    },
    error(msg, context) { this._emit('error', msg, context); },
    warn(msg, context)  { this._emit('warn', msg, context); },
    info(msg, context)  { this._emit('info', msg, context); },
    debug(msg, context) { this._emit('debug', msg, context); },
    // Return the last N buffered events (for a debug panel / console inspection).
    recent(n = 50) { return this.buffer.slice(-n); }
};
// Convenience: window.Logger.level = 'debug' from the console to crank up verbosity.
if (typeof window !== 'undefined') window.Logger = Logger;
